import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';
export const GET_LOCATION_UPDATE_REQUEST = 'GET_LOCATION_UPDATE_REQUEST';
export const GET_LOCATION_UPDATE_SUCCESS = 'GET_LOCATION_UPDATE_SUCCESS';
export const GET_LOCATION_UPDATE_ERROR = 'GET_LOCATION_UPDATE_ERROR';
export function fetchLocationUpdateAction(params) {
    return (dispatch) => {
        dispatch({
            type: GET_LOCATION_UPDATE_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers
        }, {
            pathname: '/api/4/location/update',
            action: GET_LOCATION_UPDATE_REQUEST
        }), params).then(json => dispatch({
            type: GET_LOCATION_UPDATE_SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: GET_LOCATION_UPDATE_ERROR,
                error
            });
        });
    };
}
